type EventHandler<T extends object> = (args: T) => void;

class EventEmitter<Events extends { [_K in keyof Events]: object }> {
  private events: { [K in keyof Events]?: Set<EventHandler<Events[K]>> } = {};

  on<K extends keyof Events>(event: K, handler: EventHandler<Events[K]>): void {
    if (!this.events[event]) {
      this.events[event] = new Set();
    }
    this.events[event].add(handler);
  }

  off<K extends keyof Events>(event: K, handler: EventHandler<Events[K]>): void {
    // Remove specific handler
    this.events[event]?.delete(handler);
  }

  offAll<K extends keyof Events>(event: K): void {
    // Remove all handlers for this event
    delete this.events[event];
  }

  emit<K extends keyof Events>(event: K, args: Events[K]): void {
    const eventHandlers = this.events[event];
    if (eventHandlers) {
      eventHandlers.forEach((handler) => handler(args));
    }
  }
}

export enum ApplyType {
  INDEED_APPLY = "indeedApply",
  EXTERNAL_APPLY = "externalApply",
  FAST_APPLY = "fastApply",
  ASSISTED_APPLY = "assistedApply",
}

export enum NativeApplyResult {
  SUCCESS = "SUCCESS",
  CANCEL = "CANCEL",
}

export enum ApplyStatus {
  CONFIRMED = "confirmed",
  CANCELLED = "cancelled",
  UNKNOWN = "unknown",
}

export interface RNEvents {
  submitReport: { reason: string; moreInfo: string };
  dislikeJob: { jobKey: string; vjtk: string };
  finishApply: { jobKeys: string[]; applyType?: ApplyType; status?: ApplyStatus };
  finishSaveJob: { jobKeys: string[] };
  viewJobVisibilityChanged: { isVisible: boolean };
  startAutoApply: { jobKey: string };
  submitAutoApplyApplication: { applicationId: string };
  externalApplyReturn: { jobKey: string; mobvjtk: string };
}

const eventEmitter = new EventEmitter<RNEvents>();

export default eventEmitter;
